export default __webpack_public_path__ + "static/media/new_form.6c4cec90.svg";